"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ReachedCardWithTimer_1 = __importDefault(require("../ReachedCardWithTimer"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var useLimitByInterval_1 = require("../useLimitByInterval");
var BetLimitReached = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, swr_hooks_1.useBetLimit)(), data = _a.data, mutate = _a.mutate;
    (0, useLimitByInterval_1.useLimitByIntervalOnTheGamePage)(!!data, mutate);
    if (!(data === null || data === void 0 ? void 0 : data.reached))
        return null;
    return (react_1.default.createElement(ReachedCardWithTimer_1.default, { title: t('wageringLimitReached.title'), disclaimer: react_1.default.createElement("div", null,
            t('wageringLimitReached.description'),
            react_1.default.createElement("br", null),
            t('wageringLimitReached.actionDescription')), endDate: data === null || data === void 0 ? void 0 : data.expiresAt }));
};
exports.default = BetLimitReached;
